<template>
  <v-card :loading="loading" class="pt-6" flat>
    <v-row no-gutters>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select v-model="tableProps.length" :items="[10, 25, 50, 100, 400]" dense hide-details outlined
                  @change="reloadTable()"/>
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field v-model="tableProps.filters.cnum" append-icon="mdi-phone" clear-icon="mdi-close-circle-out"
                      clearable dense hide-details label="شماره" name="name" outlined @keydown.enter="reloadTable()"
                      @click:append="reloadTable()" @click:clear="clearFilter"/>
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <date-picker v-model="tableProps.filters.date" dense display-format="jYYYY-jMM-jDD HH:mm"
                     format="YYYY-MM-DD HH:mm" label="تاریخ" outlined type="datetime" @input="reloadTable()"/>
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field v-model="tableProps.filters.src" append-icon="mdi-numeric" clearable dense label="داخلی"
                      name="name" outlined @keydown.enter="reloadTable()" @click:append="reloadTable()"
                      @click:clear="clearFilter"/>
      </v-col>

      <v-col class="pa-2" cols="12">
        <data-table :columns="columns" :data="data" :translate="translates">
          <div slot="filters"/>
        </data-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Button from '@/view/pages/Button.vue';
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";
import UsernameBtn from "@/view/pages/admin/customers/UsernameBtn";
import Provinces from "@/Provinces.json";


export default {
  name: "Index",

  data() {
    return {
      provinces: [],
      category_id: '',
      page: 1,
      messageCategories: [],
      categoryUrl: 'admin/cdr',
      query: {
        page: 1,
        search: '',
        length: 20
      },
      columns: [
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: 'مبدا',
          name: 'src',
          orderable: true,
        },
        {
          label: 'مقصد',
          name: 'dst',
          orderable: true,
        },
        {
          label: 'مدت',
          name: 'duration',
          orderable: true,
        },
        {
          label: 'وضعیت پاسخدهی',
          name: 'disposition',
          transform: (val) => {
            return this.$options.filters.callStatus(val.data.disposition);
          }
        },
        {
          label: 'تاریخ تماس',
          name: 'calldate',
          transform: (val) => {
            return val.data.calldate ? this.$options.filters.longDate(val.data.calldate) : "نامشخص!";
          }
        },
        {
          label: 'عملیات',
          name: 'actions',
          component: Button,
          handler: this.actions,
          event: 'action',
          meta: {
            permission_prefix: 'user_',
            buttons: [
              {
                label: 'پخش',
                name: 'edit',
                icon: 'play',
                class: 'btn-management',
              },
              {
                label: 'دانلود',
                name: 'edit',
                icon: 'download',
                class: 'btn-edit',
              },
              {
                label: 'کاربر',
                name: 'edit',
                icon: 'user',
                class: 'btn-buy',
              },
            ]
          }
        }
      ],
      data: {},
      url: 'admin/cdr',
      messageModal: false,
      selectedRows: [],
      tableProps: {
        search: '',
        length: 10,
        filters: {
          cnum: '',
          date: '',
          src: '',
        },
        column: 'id',
        dir: 'desc',
      },
      loading: false,
      loadingCategory: false,
      messages: [],
      messageError: [],
      message: null,
      timer: null
    }
  },

  mounted() {
    this.getCampaigns();
  },

  watch: {
    page(val) {
      this.query.page = val;
      console.log(val)
      this.getMessageCategories(this.categoryUrl, this.query)
    },
    search(val) {
      this.query.search = val;

      this.getMessageCategories(this.categoryUrl, this.query);


    },
  },

  methods: {
    clearSearch() {
      this.search = ''
    },
    getMessageQuery() {
      console.log(this.search);
      if (this.category_id !== null)
        return this.getMessage(this.category_id)
      if (this.search !== null)
        return this.messages = [];
    },
    getUserCustomers(data) {
      this.$router.push({name: 'admin.customers.owner', params: {user_id: data.user_id}})
    },
    getMessage(query) {
      this.requestApiGet(`customer/messages/${query}`).then((data) => {
        this.$modal.hideLoading();
        this.messages = data;
      }).catch(({response}) => {
        this.$modal.hideLoading();
      })
    },
    async showSms() {
      if (this.selectedRows.length === 0)
        return this.$toast.error('هیچ موردی انتخاب نشده است.');
      this.$modal.showLoading();
      await this.getMessageCategories()
      this.messageModal = true;
    },
    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    change(data, checked) {
      if (checked) {
        this.selectedRows.push(data.id);
      } else {
        let index = this.selectedRows.indexOf(data.id)
        this.selectedRows = [
          ...this.selectedRows.slice(0, index),
          ...this.selectedRows.slice(index + 1, this.selectedRows.length)
        ]

      }
      window.document.querySelector("#select_all").checked = this.selectedRows.length == this.data.data.length
    },
    getCampaigns(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
          .then(({data}) => {
            this.data = data;
          })
          .catch(({response}) => {
          })
          .finally(() => this.loading = false)
    },
    clearFilter() {
      this.$nextTick(() => {
        this.reloadTable()
      })
    },
    reloadTable(tableProps) {
      this.getCampaigns(this.url, tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    // edit(data) {
    //     this.$router.push({name: 'admin.campaign.edit', params: {id: data.id}})
    // }
  }
}
</script>

<style scoped>

</style>